import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage} from "react-intl";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import CostoFijoTooltip from "./CostoFijoTooltip";
import { limitMontoDigits } from '../ui/commons/inputs';

const PresupuestoDetalladoEditModal = (props) => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({cantidad: 0, costo: 0, detalle: ''});

	useEffect(() => {
		init();
	}, []);

	const init = () => {
		let copy = JSON.parse(JSON.stringify(data));
        copy.cantidad = props.element.cantidad;
		copy.detalle = props.element.detalle || '';
		switch (props.type) {
			case "presupuestoTarea":
				copy.costo = props.element.precio;
				break;
			case "presupuestoItem":
				copy.costo = props.element.costo;
				break;
			default:
				console.log('default');
		}
		setData(copy);
	};

	const handleMaterialChange = (name, value) => {
		let copy = JSON.parse(JSON.stringify(data));
		if (name === 'detalle') {
			if (value.length <= 60) {
				copy[name] = value;
			}
		} else {
			if (name === 'costo') {
				const limited = limitMontoDigits(value);
				if ((limited && limited >= 0) || !limited) {
					copy[name] = limited;
				}
			} else if ((value && value >= 0) || !value) {
				copy[name] = value;
			}
		}
		setData(copy);
	}

	// Calcular cuántos campos están activos en la tabla (sin detalle, que va aparte)
	const camposActivosTabla = [props.enabledCantidad, props.enabledCosto].filter(Boolean).length;

	// Determinar el ancho máximo según la cantidad de campos activos en la tabla
	const getMaxWidth = () => {
		if (camposActivosTabla === 1) return '300px';
		return '500px';
	};

	return (
		<>
			<div>
				<div className="text-center mt-2">
					<h3>
						{
							props.element.id_item ?
								<FormattedMessage id="presupuesto.repuesto" defaultMessage="Repuesto" />
							: props.element.id_tarea ?
								<FormattedMessage id="presupuesto.mano_de_obra" defaultMessage="Mano de Obra" />
							: <FormattedMessage id="presupuesto.error_nombre" defaultMessage="No se encontró el nombre del repuesto o tarea" />
						}
						:&nbsp;
						{props.element.descripcion ? (props.element.descripcion) : (props.element.nombre ? props.element.nombre : '')}
					</h3>
				</div>
				<div className="table-responsive" style={{padding: "15px", display: 'flex', justifyContent: 'center'}}>
					<table
						id="dataTable"
						className="dataTable table nowrap server-side table-hover dataTableMovil"
						style={{maxWidth: getMaxWidth(), width: '100%'}}
					>
						<thead>
							<tr>
								{
									props.enabledCantidad ?
										<th scope="col" style={{textAlign: 'center'}}>
											<FormattedMessage id="presupuesto.cantidad" defaultMessage="Cantidad" />
										</th>
									: null
								}
                                {
									props.enabledCosto ?
                                        <th scope="col" style={{textAlign: 'center'}}>
											<span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                            	<FormattedMessage id="Ppresupuesto.precio" defaultMessage="Precio" />
												<CostoFijoTooltip
													costoFijo={props.element.costo_fijo === 1}
													descripcion={props.element.descripcion || props.element.nombre}
												/>
											</span>
                                        </th>
									: null
								}
							</tr>
						</thead>
						<tbody>
							<tr key={props.element.id}>
								{
									props.enabledCantidad ?
										<td className="all custom-lineHeight" style={{textAlign: 'center'}}>
											<TextField
												id="number"
												type="number"
												onChange={e => handleMaterialChange('cantidad', e.target.value)}
												InputProps={{
													inputProps: {
														min: 0,
														'data-outline-none': 'true',
														style: { textAlign: 'center' }
													}
												}}
												variant="standard"
												value={data.cantidad}
												fullWidth
											/>
										</td>
									: null
								}
								{
									props.enabledCosto ?
										<td className="all custom-lineHeight" style={{textAlign: 'center'}}>
											<TextField
												id="standard"
												type="number"
												disabled={props.element.costo_fijo === 1}
												onChange={e => handleMaterialChange('costo', e.target.value)}
												InputProps={{
													inputProps: {
														min: 0,
														'data-outline-none': 'true',
														style: { textAlign: 'center' }
													}
												}}
												variant="standard"
												value={data.costo}
												fullWidth
											/>
										</td>
									: null
								}
							</tr>
						</tbody>
					</table>
				</div>
				{
					props.enabledDetalle ?
						<div style={{padding: '0 15px 15px 15px'}}>
							<label style={{fontWeight: 'bold', marginBottom: '4px', display: 'block'}}>
								<FormattedMessage id="presupuesto.detalle" defaultMessage="Detalle" />
							</label>
							<TextField
								id="detalle"
								type="text"
								multiline
								rows={2}
								onChange={e => handleMaterialChange('detalle', e.target.value)}
								inputProps={{
									'data-outline-none': 'true',
									maxLength: 60
								}}
								variant="outlined"
								value={data.detalle}
								fullWidth
							/>
							<div style={{textAlign: 'right', fontSize: '0.75rem', color: '#666', marginTop: '2px'}}>
								{data.detalle ? data.detalle.length : 0}/60
							</div>
						</div>
					: null
				}
				<div className="text-center d-flex justify-content-center">
					<button type="button" className="btn btn-primary mr-1" onClick={(e) => props.updateElement(data)}>
						<i className="fa fa-check-circle"></i><FormattedMessage id="presupuesto.guardar" defaultMessage=" Guardar"/>
					</button>
					<button type="button" className="btn btn-danger" onClick={(e) => props.closeModalEdit()}>
						<i className="fa fa-times-circle"></i> { props.intl.formatMessage({ id: 'presupuesto.cancelar', defaultMessage: 'Cancelar' })}
					</button>
				</div>
			</div>
		</>
	);
};

export default PresupuestoDetalladoEditModal;
